import { useEffect } from "react";
import { Phone, MapPin, Clock, Mail } from "lucide-react";
import { PHONE, PHONE_HREF, ADDRESS } from "@/data/site";
import { QuoteForm } from "@/components/QuoteForm";
import { Reveal, MaskedLine } from "@/components/Reveal";

export default function Contact() {
  useEffect(() => {
    document.title = "Contact Us | Irvine Water Heater Man";
  }, []);

  return (
    <div>
      <section className="navy-grain text-white px-4 sm:px-6 pt-14 sm:pt-20 pb-24" data-testid="contact-hero">
        <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-14 items-start">
          <div>
            <h1 className="font-heading font-black tracking-tight text-4xl sm:text-5xl lg:text-6xl leading-[1.05]">
              <MaskedLine>Talk To A</MaskedLine>
              <MaskedLine delay={0.15}><span className="text-[#FF6500]">Specialist Now.</span></MaskedLine>
            </h1>
            <MaskedLine delay={0.3}>
              <p className="text-white/70 text-lg leading-relaxed max-w-xl mt-6 mb-10">
                Fastest path: call. A live person answers 24/7 — nights, weekends, holidays. Or send the form and we'll call you back within minutes during business hours.
              </p>
            </MaskedLine>
            <div className="space-y-6">
              <a href={PHONE_HREF} data-testid="contact-call-btn" className="inline-flex items-center gap-3 bg-[#FF6500] text-white font-heading font-bold text-xl px-8 py-4 rounded-full hover:bg-[#E85C0D] hover:scale-105 transition-[background-color,transform]">
                <Phone className="w-6 h-6" /> {PHONE}
              </a>
              <div className="flex items-start gap-3 text-white/70">
                <MapPin className="w-5 h-5 text-[#FF6500] mt-0.5" /> {ADDRESS}
              </div>
              <div className="flex items-start gap-3 text-white/70">
                <Clock className="w-5 h-5 text-[#FF6500] mt-0.5" /> Open 24/7 for water heater emergencies · Office hours 7am–7pm daily
              </div>
              <div className="flex items-start gap-3 text-white/70">
                <Mail className="w-5 h-5 text-[#FF6500] mt-0.5" /> Prefer text? Send the form and reply to our confirmation.
              </div>
            </div>
          </div>
          <Reveal delay={0.2}>
            <div id="quote" className="bg-white rounded-2xl p-6 sm:p-8 shadow-2xl">
              <h2 className="font-heading font-extrabold text-2xl text-gray-900 mb-1">Request a Free Estimate</h2>
              <p className="text-gray-500 text-sm mb-5">Four quick fields. No spam, no obligation.</p>
              <QuoteForm idPrefix="contact" />
            </div>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
